module.exports = __webpack_public_path__ + "static/media/mailnews_12.f658dd41.ico";